import reactReplacePlaceholder from 'react-replace-placeholder';

import BpkText, {
  TEXT_STYLES,
  TEXT_COLORS,
} from '@skyscanner/backpack-web/bpk-component-text';

import constants from '../constants';
import withStrings from '../withStrings';

import type { QuoteLinkProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DestinationsExplorer';

import STYLES from './QuoteLink.module.scss';

const {
  STRINGS: { FROM_PRICE, GET_PRICES },
} = constants;

const QuoteLink = ({ price, strings }: QuoteLinkProps) => (
  <BpkText
    color={TEXT_COLORS.textPrimary}
    className={STYLES.QuoteLink}
    textStyle={TEXT_STYLES.label1}
  >
    {price
      ? reactReplacePlaceholder(strings[FROM_PRICE], { price }, '@@', '@@')
      : strings[GET_PRICES]}
  </BpkText>
);

export default withStrings(QuoteLink);
